import { useRef } from 'react';

interface CaptureRequest {
  requestId: string;
  baseVersionId: string | null;
  name: string;
}

/** A refreshed history must not rewrite an attempt whose acknowledgement was
 * lost. Keep its original base until the user starts a different request. */
export function useVersionCaptureRequest() {
  const bases = useRef(new Map<string, string | null>());
  return (request: CaptureRequest): CaptureRequest => {
    if (!bases.current.has(request.requestId)) {
      bases.current.set(request.requestId, request.baseVersionId);
    }
    return { ...request, baseVersionId: bases.current.get(request.requestId)! };
  };
}
